const typography = {
    fontSize: 12,
    h1: {
        fontFamily: `opensans-light`,
        fontSize: '31px',
    },
    h2: {
        fontFamily: `opensans-light`,
        fontSize: '22px',
    },
    h3: {
        fontSize: '22px',
        fontFamily: `opensans-bold`,
        fontWeight: '800',
        letterSpacing: '-0.5px',
    },
    h4: {
        fontSize: '14px',
        fontFamily: `'opensans-bold'`,
        letterSpacing: '-0.5px',
    },
    h5: {
        fontSize: '14px',
        fontFamily: `'opensans-regular'`,
        letterSpacing: '-0.5px',
    },
    subtitle1: {
        fontSize: '12px',
        fontFamily: `'opensans-bold'`,
        fontWeight: 'bold',
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
    },
    subtitle2: {
        fontFamily: `'opensans-bold'`,
        fontSize: '11px',
        letterSpacing: '0.2px',
        textTransform: 'uppercase',
    },
    subtitle3: {
        fontSize: '11px',
        fontFamily: `'opensans-bold'`,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
    },
    subtitle4: {
        fontSize: '10px',
        fontFamily: `'opensans-bold'`,
        textTransform: 'uppercase',
    },
    body1: {
        fontSize: '12px',
        fontFamily: `'opensans-regular'`,
    },
    body2: {
        fontFamily: `'opensans-bold'`,
        letterSpacing: ' 0.4px',
    },
    body3: {
        fontSize: '14px',
        fontFamily: `'opensans-italic'`,
        letterSpacing: '0.5px',
    },
    body4: {
        fontFamily: `'opensans-italic'`,
        fontSize: '12px',
        letterSpacing: '0px',
    },
    body5: {
        fontSize: '11px',
        fontFamily: `'opensans-regular'`,
    },
    button: {
        fontSize: '12px',
        fontFamily: `'opensans-bold'`,
        letterSpacing: '0.6px',
        textTransform: 'uppercase',
        textAlign: 'center',
    },
    button2: {
        fontSize: '10px',
        fontFamily: `'opensans-bold'`,
        letterSpacing: '0.4px',
        textTransform: 'uppercase',
        textAlign: 'center',
    },
    h6: undefined,
    caption: undefined,
    overline: undefined,
};

export { typography as default };
//# sourceMappingURL=typography.js.map
